import React, { useRef, useState, useEffect, Fragment, Component } from "react";
import UploadService from "./upload-files.service";
import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import CancelIcon from "@mui/icons-material/Cancel";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import ProgressBar from "react-bootstrap/ProgressBar";
import FileUpload from "./FileUpload";
import axios from "../../../../api/axios";
import { Editor } from "@tinymce/tinymce-react";

import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";

import {
  Typography,
  Grid,
  Select,
  TextField,
  Checkbox,
  CssBaseline,
  RadioGroup,
  FormLabel,
  MenuItem,
  FormGroup,
  FormControl,
  FormControlLabel,
  InputLabel,
} from "@mui/material";

import "./UserOrderStyles.css";
import Form from "react-bootstrap/Form";
import { url } from "../../../../configlink";

export default function DispatchEmail() {
  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [currentFile, setCurrentFile] = useState(undefined);
  const [openDialogName, setOpenDialog] = useState(null);

  const [rows, setRows] = useState([]);
  const [orderId, setOrderId] = useState("");
  const [isSubmitDisabled, setIsSubmitDisabled] = useState("disabled");

  const sentNumber = useRef(0);
  const totalNumber = useRef(0);

  const [progress, setProgress] = useState(0);
  const [progressMessage, setProgressMessage] = useState("Sending");
  const [workingFileName, setWorkingFileName] = useState("");
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [subject, setSubject] = useState("");
  const [emailContent, setEmailContent] = useState("");

  //Change to JavaScript
  // type HtmlEditorProps = {
  //   name: string,
  // };

  const closeDialog = () => {
    setOpenDialog(null);
  };

  useEffect(() => {
    getCategoryDrpDown();
  }, []);

  const getCategoryDrpDown = async () => {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_email_template_dropbox`, {
          withCredentials: true,
        }
      );
      setEmailTemplates(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const selectTemplateChange = async (event) => {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_email_template_by_templateid?templateId=` +
          event.target.value, {
            withCredentials: true,
          }
      );

      setSubject(response.data[0].subject);
      setEmailContent(response.data[0].html);
    } catch (error) {
      console.error(error);
    }

    //getRefUserDetail();
    //getItems();
  };

  const openDialog = () => {
    /*alert('Selected Userid====' + userId);
    switch (openDialogName) {
      case 1:
        setOpenDialog(openDialogName);
        handleClose();
    }*/
  };

  function handleChange(event) {
    console.log(event.target.value);
    setOrderId(event.target.value);
  }

  const cancelForm = () => {
    //this.setState({ open: false });
    //this.state.onClose();
  };

  const dispatchEmail = (row) => {
    setWorkingFileName(row.emailAddress);

    axios
      .post(`${url}/api/admin/post_dispatch_email_lists`, {
        data: JSON.stringify(row),
        subject: subject,
        content: emailContent,
      })
      .then((res) => {
        sentNumber.current = sentNumber.current + 1;
        ///console.log("setNumber======" ,sentNumber.current);

        setProgress(
          Math.round((sentNumber.current * 100) / totalNumber.current)
        );

        if (res.data[0].result === "success") {
          console.log("success");
        }
      });
  };

  const handleSubmit = async () => {
    totalNumber.current = rows.length;
    sentNumber.current = 0;
    // setProgress(Math.round(sentNumber.current / totalNumber.current) * 100);
    setIsSubmitDisabled("disabled");

    let delay = 0;
    const delayIncrement = 2000;

    const promises = rows.map((row) => {
      delay += delayIncrement;
      return new Promise((resolve) => setTimeout(resolve, delay)).then(() =>
        dispatchEmail(row)
      );
    });

    let batches = await Promise.all(promises)
      .then((values) => {
        console.log("it is completed");
        setIsSubmitDisabled("");
        setTimeout(() => setProgressMessage("Sent"), 2000);
      })
      .catch((error) => {
        console.error(error.message);
      });
  };

  const handleDeleteClick = (id) => () => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleKeyDown = async (event) => {
    if (event.key === "Enter") {
      try {
        const response = await axios.get(
          `${url}/api/admin/get_userinfo_by_orderid`,
          {
            params: { orderId: orderId },
            withCredentials: true,
          }
        );

        if (response.data.length > 0) {
          //setRows(rows.filter(row => row.id !== response.data[0].id));

          const newRow = {
            id: response.data[0].id,
            orderId: response.data[0].orderId,

            firstName: response.data[0].firstName,
            lastName: response.data[0].lastName,
            emailAddress: response.data[0].emailAddress,
          };
          setRows([...rows, newRow]);
        }
        //setRows(response.data);
        //console.log('return data====' + response.data[0].firstName);
      } catch (error) {
        console.error(error);
      }

      setOrderId("");
    }
  };

  const columns = [
    { field: "id", headerName: "id", type: "number", width: 100 },
    {
      field: "orderId",
      headerName: "Order#",
      type: "numberstring",
      width: 80,
      editable: false,
    },
    {
      field: "firstName",
      headerName: "FileName",
      type: "string",
      width: 110,
      editable: false,
    },
    {
      field: "lastName",
      headerName: "LastName",
      type: "string",
      width: 110,
      editable: false,
    },
    {
      field: "emailAddress",
      headerName: "Email",
      type: "string",
      width: 280,
      editable: false,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "",
      width: 15,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            key={id}
            icon={<DeleteIcon />}
            onClick={handleDeleteClick(id)}
            label="Edit"
            className="textPrimary"
            color="inherit"
          />,
        ];
      },
    },
  ];

  return (
    <div>
      <div className="email-container">
        <div className="email-header">
          <div className="email-left-header">
            <Typography
              variant="h5"
              sx={{ color: "var(--color-primary-purple)", fontWeight: 700 }}
              component="div"
            >
              Batch Group Email
            </Typography>
          </div>

          <div className="email-right-header">
            <IconButton
              aria-label="Forward"
              sx={{ color: "var(--color-primary-purple)" }}
              onClick={() => handleSubmit()}
            >
              <ForwardToInboxIcon />
            </IconButton>
            <IconButton
              aria-label="history"
              sx={{ color: "var(--color-primary-purple)" }}
            >
              <ManageSearchIcon />
            </IconButton>
            <IconButton
              aria-label="cancel"
              sx={{ color: "var(--color-primary-purple)" }}
            >
              <CancelIcon />
            </IconButton>
          </div>
        </div>

        <Divider component="div" role="presentation" />

        <div className="email-content">
          <div className="email-left-area">
            <div className="email-left-header">Enter Receiver Info</div>
            <div className="h-full">
              <Grid container alignItems="center" spacing={3}>
                <Grid item xs={12} className="h-full">
                  <TextField
                    id="orderId"
                    label="Order #"
                    fullWidth
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    value={orderId}
                    defaultValue="Normal"
                    size="small"
                    className="dispatch_textfield"
                  />
                </Grid>

                <Grid item xs>
                  <DataGrid
                    initialState={{
                      columns: {
                        columnVisibilityModel: {
                          // Hide columns status and traderName, the other columns will remain visible
                          id: false,
                        },
                      },
                    }}
                    hideFooter
                    pagination={false}
                    autoPageSize
                    style={{
                      height: "613px",
                      overflow: "auto",
                    }}
                    columnHeaderHeight={30}
                    rowHeight={30}
                    rows={rows}
                    columns={columns}
                  />
                </Grid>
              </Grid>
            </div>
          </div>
          <div className="email-right-area">
            <div className="email-left-header">Email Template</div>

            <Grid container alignItems="center" spacing={3}>
              <Grid item xs={12}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-select-small-label">Template</InputLabel>
                  <Select
                    id="email_template"
                    label="Email Template"
                    onChange={selectTemplateChange}
                  >
                    <MenuItem value={0}>All </MenuItem>
                    {emailTemplates.map((data, i) => (
                      <MenuItem value={data.templateId} key={i}>
                        {data.templateSubject}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="subject"
                  label="Subject"
                  fullWidth
                  onChange={(e) => setSubject(e.target.value)}
                  value={subject}
                  size="small"
                />
              </Grid>

              <Grid item xs={12}>
                <div className="email-dispatch_email_template_box">
                  <Editor
                    apiKey="qz3daa86k5eani3tegrdjjjwt7y261pe36xncqbg9s6o57zr"
                    value={emailContent}
                    init={{
                      height: 550,
                      // width: 700,
                      selector: "textarea",
                      menubar: false,
                      content_style:
                        "div { margin: 0px; border: 0px solid red; padding: 0px; } " +
                        ".blue { color: blue; } .red { color: red; }",
                    }}
                    // onEditorChange={(content: string) => {
                    //   setEmailContent(content);
                    //   // setValue(name, content)
                    // }}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </div>

        {workingFileName.length > 0 && (
          <>
            <div className="mx-[20px] mt-[20px]">
              <div>
                <ProgressBar
                  now={progress}
                  variant="progresspurple"
                  active="true"
                  label={progressMessage}
                  sx={{ backgroundColor: "red" }}
                />
              </div>
              <div className="email-right-footer">{workingFileName}</div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
